
import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter } from 'vuex-class';
import Head from './head.vue';
import Robot from './Robot.vue';

@Component({
  components: { Head, Robot }
})
export default class LayOut extends Vue {
  showFooter: boolean = true;

  mounted() {
    if (this.$route.name === 'board') {
      this.showFooter = false;
    }
  }
  watchMenuChange(key: string) {
    if (key === 'board') {
      this.showFooter = false;
    } else {
      this.showFooter = true;
    }
  }
}
